<template>
    <div class="col-lg-12 mx-2">
        <!-- Ad Component -->
        <GoogleAds />
        
        <ContentContainer>
            <template v-slot:content>
                <div v-if="registrationtype == 1" class="p-4 my-2">
                    <h2 class="my-4">Getting Started - Volunteer Setup</h2>

                    <!-- Change Password Prompt (hidden after successful change) -->
                    <div v-if="!passwordChanged" class="alert alert-warning d-flex align-items-start gap-3 mb-4" role="alert">
                        <i class="material-icons mt-1" style="font-size: 24px;">lock</i>
                        <div>
                            <h6 class="fw-bold mb-1">Change Your Password</h6>
                            <p class="mb-2 text-sm">For security reasons, please change the generated password that was sent to your email.</p>
                            <button type="button" class="btn btn-sm btn-warning mb-0" @click="showChangePasswordModal = true">
                                <i class="material-icons me-1" style="font-size: 16px; vertical-align: middle;">vpn_key</i>
                                Click here to change password
                            </button>
                        </div>
                    </div>

                    <h4 class="mb-4">Volunteer Setup Summary</h4>
                    <ul>
                        <li> Click on the Join an existing Organization section below</li>
                        <li> Enter part of the name of your organization and click on the search button</li>
                        <li> The search should return a list of organizations</li>
                        <li> Click on the appropriate organization that you are requesting access to</li>
                        <li> Enter a reason for joining the organization (an admininistrator may need to
                            approve
                            your submission)</li>
                        <li> Once an admin has approved your submission, you will be ready to enter your
                            availability and scheduling preferences</li>
                        <li> You will now be able to select your preferred activities/services, update your
                            availability, and set scheduling rules</li>
                        <li> Additionally, you will also be able to receive text notifications when you are
                            scheduled (*save your mobile number for this feature to work)</li>
                    </ul>

                    <ul>
                        <li class="mt-2 list-type-none"><a href="https://www.churchscheduling.com/knowledge-base/"
                                class="text-blue"><u>Click
                                    here</u></a> to get more
                            setup
                            details in the Help documentation</li>

                        <li class="list-type-none">We are here to HELP. Contact us to help you get setup
                        </li>
                    </ul>

                    <div class="d-flex justify-content-start mt-2">
                        <router-link to="join-organization">
                            <!-- <p class="text-blue"><u>Click here to launch the Join Organization</u></p> -->
                             <MaterialButton color="success" > Click here to launch the Join Organization </MaterialButton>
                        </router-link>
                    </div>
                </div>
                <div v-else class="p-4 my-2">
                    <h2 class="my-4">Getting Started - Admin Setup</h2>

                    <!-- Change Password Prompt (hidden after successful change) -->
                    <div v-if="!passwordChanged" class="alert alert-warning d-flex align-items-start gap-3 mb-4" role="alert">
                        <i class="material-icons mt-1" style="font-size: 24px;">lock</i>
                        <div>
                            <h6 class="fw-bold mb-1">Change Your Password</h6>
                            <p class="mb-2 text-sm">For security reasons, please change the generated password that was sent to your email.</p>
                            <button type="button" class="btn btn-sm btn-warning mb-0" @click="showChangePasswordModal = true">
                                <i class="material-icons me-1" style="font-size: 16px; vertical-align: middle;">vpn_key</i>
                                Click here to change password
                            </button>
                        </div>
                    </div>

                    <h4 class="mb-4">Organization Setup Summary</h4>
                    <ul>
                        <li> Create a new organization</li>
                        <li> Create a location/branch</li>
                        <li> Add skill/roles</li>
                        <li> Add activities/events (*be sure to keep the Auto-scheduling setting set to
                            disabled).
                        </li>
                        <li> Setup workgroups by clicking on the Workgroups section (Rules are applied at
                            the
                            workgroup level)</li>
                        <li> Setup recurrence ( how often/when the activity should be scheduled )</li>
                        <li> Add volunteers</li>
                        <li> Add volunteers to specific skills by going to the Manage Skills page and
                            editing
                            each skill</li>
                        <li> When the steps above are complete, go back to edit the Activity/Event, set the
                            Auto-schedule option to enabled</li>
                    </ul>

                    <ul>
                        <li class="mt-2 list-type-none"><a href="https://www.churchscheduling.com/knowledge-base/"
                                class="text-blue"><u>
                                    Click
                                    here</u> </a> to get more
                            setup details in the Help documentation </li>

                        <li class="list-type-none">We are here to HELP. Contact us to assist you in getting
                            your
                            organization setup</li>
                    </ul>

                    <div class="d-flex justify-content-start mt-2">
                        <router-link to="setup-organization">
                             <MaterialButton color="success" class="pulse-glow"> Click here to launch the Setup Organization </MaterialButton>
                        </router-link>
                    </div>

                </div>
            </template>
        </ContentContainer>
    </div>

    <!-- Change Password Modal -->
    <ContentModal v-model="showChangePasswordModal" title="Change Password" size="md">
        <div class="w-75 mx-auto py-3">
            <p class="text-secondary mb-3">Please enter a new password to replace the generated one.</p>
            <form @submit.prevent="handleChangePassword">
                <div class="my-2">
                    <MaterialInput id="new-password" type="password" v-model="newPassword"
                        label="Enter your new password" name="newPassword" :isRequired="true" />
                </div>
                <div class="my-2">
                    <MaterialInput id="confirm-new-password" type="password" v-model="confirmNewPassword"
                        label="Retype your password" name="confirmNewPassword" :isRequired="true" />
                </div>
                <div class="mb-3">
                    <p class="text-secondary text-sm">*Password must be at least 6 characters.</p>
                </div>
                <div v-if="changePasswordError">
                    <p class="text-danger text-center text-sm">{{ changePasswordError }}</p>
                </div>
                <MaterialButton class="mb-2 py-2" size="sm" variant="gradient" color="success" fullWidth>
                    Change Password
                </MaterialButton>
            </form>
        </div>
    </ContentModal>
</template>

<script>
// import Modal from '@/components/Modal/Modal.vue';
import ContentContainer from '@/components/PageLayout/ContentContainer.vue';
import ContentModal from '@/components/Modal/ContentModal.vue';
import MaterialInput from '@/components/common/MaterialInput.vue';
// import TabCard from '@/components/Cards/TabCards.vue';
import { mapGetters, mapActions } from 'vuex';
import { useToast } from 'vue-toast-notification';
import { getRegistrationType } from '../utils/SessionDataHandler';
import MaterialButton from '@/components/common/MaterialButton.vue';
import GoogleAds from '@/components/GoogleAds/GoogleAds.vue';
import LoggerService from '@/services/LoggerService';

const toast = useToast();

export default {
    name: "setup",
    data() {
        return {
            isModalOpen: false,
            modalHeading: "",
            modalContent: "",
            activeTab: 'admin',
            showChangePasswordModal: false,
            passwordChanged: false,
            newPassword: '',
            confirmNewPassword: '',
            changePasswordError: '',
        };
    },
    components: {
        ContentContainer,
        ContentModal,
        MaterialInput,
        MaterialButton,
        GoogleAds,
        // TabCard,
        // Modal
    },
    computed: {
        ...mapGetters([
            "stDashboardData",
            "stChangePasswordResponse",
            "stSessionData",
        ]),
        registrationtype() {
            return getRegistrationType();
        },
    },
    methods: {
        ...mapActions(['changePassword']),
        openModal(item) {
            this.isModalOpen = true;
            this.modalHeading = item.label;
        },
        closeModal() {
            this.isModalOpen = false;
        },
        async handleChangePassword() {
            this.changePasswordError = '';
            if (this.newPassword.length < 6) {
                this.changePasswordError = 'Password must be at least 6 characters';
                return;
            }
            if (this.newPassword !== this.confirmNewPassword) {
                this.changePasswordError = 'Passwords do not match';
                return;
            }
            try {
                await this.changePassword(this.newPassword);
                LoggerService.logDataOperation(
                    'PASSWORD_CHANGE',
                    'user',
                    this.stSessionData?.personId,
                    { action: 'Password changed from Setup page' },
                    this.stSessionData?.personId
                );
                toast.success(this.stChangePasswordResponse?.message || 'Password changed successfully', {
                    position: 'top-right',
                });
                this.newPassword = '';
                this.confirmNewPassword = '';
                this.showChangePasswordModal = false;
                this.passwordChanged = true;
            } catch (err) {
                console.error('Error changing password:', err);
                this.changePasswordError = 'Failed to change password. Please try again.';
            }
        },
    },
};
</script>

<style lang="css" scoped>
.text-blue {
    color: blue;
}

.list-type-none {
    list-style: none;
}

.pulse-glow {
    animation: pulse-glow-animation 1.5s ease-in-out infinite;
}

@keyframes pulse-glow-animation {
    0%, 100% {
        box-shadow: 0 0 5px rgba(76, 175, 80, 0.4);
        transform: scale(1);
    }
    50% {
        box-shadow: 0 0 20px rgba(76, 175, 80, 0.8), 0 0 40px rgba(76, 175, 80, 0.4);
        transform: scale(1.03);
    }
}
</style>
